import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { getTenderByGuid, getActiveTenders } from '../../api/tenderService';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

const TendersDetail = () => {
  const { urlTag } = useParams();
  const location = useLocation();
  const guidFromState = location.state?.guid;
  const [tender, setTender] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTenderDetail = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      let guid = guidFromState;

      // Eğer state'den guid gelmemişse (direkt URL girişi), urlTag ile bul
      if (!guid && urlTag) {
        console.log('GUID not found in state, fetching by urlTag:', urlTag);
        const allTendersResponse = await getActiveTenders(1, 1000);
        
        if (allTendersResponse.isSuccess && allTendersResponse.data?.items) {
          const foundTender = allTendersResponse.data.items.find(
            item => item.urlTag === urlTag
          );
          
          if (foundTender) {
            guid = foundTender.guid;
            console.log('Found tender with guid:', guid);
          } else {
            console.log('Tender not found with urlTag:', urlTag);
            setError('İhale bulunamadı');
            setLoading(false);
            return;
          }
        } else {
          console.log('Failed to fetch tenders list');
          setError('İhaleler yüklenirken bir hata oluştu');
          setLoading(false);
          return;
        }
      }

      if (!guid) {
        console.log('No guid available');
        setError('İhale bilgisi bulunamadı');
        setLoading(false);
        return;
      }

      console.log('Fetching tender detail for guid:', guid);
      const response = await getTenderByGuid(guid);
      console.log('Tender detail response:', response);
      
      if (response.isSuccess && response.data) {
        setTender(response.data);
        setError(null);
      } else {
        setError(`İhale detayı yüklenirken bir hata oluştu: ${JSON.stringify(response)}`);
      }
    } catch (error) {
      console.error('Error in fetchTenderDetail:', error);
      setError(`İhale detayı yüklenirken bir hata oluştu: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  }, [urlTag, guidFromState]);

  useEffect(() => {
    fetchTenderDetail();
  }, [fetchTenderDetail]);

  const formatDate = (dateString) => {
    try {
      if (!dateString || dateString === '0001-01-01T00:00:00' || dateString.includes('0001-01-01')) {
        return 'Tarih belirtilmemiş';
      }
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return 'Geçersiz tarih';
      }
      return format(date, 'dd MMMM yyyy', { locale: tr });
    } catch (error) {
      return dateString;
    }
  };

  if (loading) {
    return (
      <div className="tenders-detail-page">
        <div className="container-fluid">
          <div className="loading">Yükleniyor...</div>
        </div>
      </div>
    );
  }

  if (error || !tender) {
    return (
      <div className="tenders-detail-page">
        <div className="container-fluid">
          <div className="alert alert-danger">{error || 'İhale bulunamadı'}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="tenders-detail-page">
      <div className="container-fluid">
        <div className="row">
            <QuickMenu />
            <div className="col-md-10">
            <div className="tenders-detail">
          <div className="tenders-detail-title">
            <h2 id="tenders-header">{tender.header}</h2>
          </div>

          <div className="tenders-detail-content">
            <div className="tenders-detail-boxes">
              <div className="tenders-detail-box">
                <div className="tenders-detail-box-left">
                  <span>İhale Konusu</span>
                </div>
                <div className="tenders-detail-box-right">
                  <p id="tenders-subject">{tender.header}</p>
                </div>
              </div>
              <div className="tenders-detail-box">
                <div className="tenders-detail-box-left">
                  <span>İhale Birimi</span>
                </div>
                <div className="tenders-detail-box-right">
                  <p id="tenders-department">{tender.department}</p>
                </div>
              </div>
              {tender.fileUrl && (
                <div className="tenders-detail-box file">
                  <div className="tenders-detail-box-left">
                    <span>Doküman URL</span>
                  </div>
                  <div className="tenders-detail-box-right">
                    <p id="tenders-url">
                      <a href={tender.fileUrl} target="_blank" rel="noopener noreferrer">
                        İhale Dosyasını İndir
                      </a>
                    </p>
                  </div>
                </div>
              )}
              {tender.address && (
                <div className="tenders-detail-box">
                  <div className="tenders-detail-box-left">
                    <span>İhalenin Yapılacağı Adres</span>
                  </div>
                  <div className="tenders-detail-box-right">
                    <p id="tenders-address">{tender.address}</p>
                  </div>
                </div>
              )}
              <div className="tenders-detail-box">
                <div className="tenders-detail-box-left">
                  <span>İhale Tarihi/Saati</span>
                </div>
                <div className="tenders-detail-box-right">
                  <p id="tenders-date">{formatDate(tender.date)}</p>
                </div>
              </div>
              <div className="tenders-detail-box">
                <div className="tenders-detail-box-left">
                  <span>İhale Durum:</span>
                </div>
                <div className="tenders-detail-box-right">
                  <p id="tenders-status" style={{ display: 'flex', alignItems: 'center' }}>
                    {/* <span 
                      style={{ 
                        display: 'inline-block', 
                        width: '12px', 
                        height: '12px', 
                        borderRadius: '50%', 
                        backgroundColor: tender.statusColorCode || '#ccc',
                        marginRight: '8px'
                      }} 
                    /> */}
                    {tender.statusName}
                  </p>
                </div>
              </div>
              <div className="tenders-detail-box">
                <div className="tenders-detail-box-left">
                  <span>İhale Metni</span>
                </div>
                <div className="tenders-detail-box-right">
                  <div 
                    id="tenders-detail" 
                    className="tender-detail-content"
                    dangerouslySetInnerHTML={{ __html: tender.detail || '' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
            </div>
        </div>
      
      </div>
    </div>
  );
};

export default TendersDetail;
